import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b676ff2c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mb-5" }
const _hoisted_2 = { class: "page-title" }
const _hoisted_3 = { class: "max-w-screen-xl mx-auto" }
const _hoisted_4 = { class: "flex flex-wrap -mx-4" }
const _hoisted_5 = { class: "w-full lg:w-1/4 px-3" }
const _hoisted_6 = { class: "mb-5" }
const _hoisted_7 = { class: "card w-75 shadow-xl" }
const _hoisted_8 = { class: "card-body items-center text-center" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "card-title" }, "Image Web", -1))
const _hoisted_10 = { class: "mb-5" }
const _hoisted_11 = { class: "card w-75 shadow-xl" }
const _hoisted_12 = { class: "card-body items-center text-center" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "card-title" }, "Image Mobile", -1))
const _hoisted_14 = { class: "w-full lg:w-3/4 px-4" }
const _hoisted_15 = { class: "card w-full shadow-xl" }
const _hoisted_16 = { class: "card-body" }
const _hoisted_17 = { class: "w-full" }
const _hoisted_18 = { class: "card-actions" }
const _hoisted_19 = { key: 0 }

import { onBeforeMount, ref } from 'vue';
import { useRoute } from 'vue-router';
import ApiService from "@/_services/api.service";
import swal from "@/_helpers/swal";
import { useRouter } from "vue-router";
import UploadImage from "@/components/forms/UploadImage.vue";
import {fetchNewsByUuid} from "@/_services/homepage/news";
import {INews} from "@/models/homepage/INews";
const submitBtnLabel = 'Editer';

export default /*#__PURE__*/_defineComponent({
  __name: 'EditNews',
  setup(__props) {

const title = ref<string>("Edition d'une nouveauté");
const news = ref<INews>({} as INews);
const route = useRoute();
const uuidRouteParam = ref<string>("");
const router = useRouter();
const loading = ref<boolean>(true);

onBeforeMount(async () => {
    loading.value = true;
    uuidRouteParam.value = route.params.uuid.length ? route.params.uuid as string : "";
    if (uuidRouteParam.value.length) {
        news.value = await fetchNewsByUuid(uuidRouteParam.value);
        await hydrateNewsForm(news.value);
        loading.value = false;
    }
});

const form = ref<INews>({
    position: null,
    imageWeb: '',
    imageMobile: '',
    product: ''
});

const hydrateNewsForm = (news: INews) => {
    form.value = {
        position: news.position,
        imageWeb: news.imageWeb,
        imageMobile: news.imageMobile,
        product: news.product
    }
}

const onSubmit = async (formData) => {
    try {
        if (null == form.value.imageWeb || null == form.value.imageMobile) {
            swal.warning('Les deux images sont obligatoires.');
            return false;
        }
        const payload = {
            position: parseInt(formData.position),
            product: null !== form.value.product ? `/api/master-product/${form.value.product}` : null,
            imageWeb: null !== form.value.imageWeb ? `/api/images/${form.value.imageWeb.uuid}` : null,
            imageMobile: null !== form.value.imageMobile ? `/api/images/${form.value.imageMobile.uuid}` : null
        }
        swal.confirm(`Êtes-vous sûr de vouloir éditer ?`,
            "Annuler",
            submitBtnLabel
        )
            .then((results) => results.isConfirmed && updateNews(payload))
    } catch (err: any) {
        swal.error(err.errors[0]);
    }
}

const updateNews = (data) => {
    if(uuidRouteParam.value.length) {
        ApiService.patch('news', uuidRouteParam.value, data)
            .then(() => {
                loading.value = false;
                swal.info("Edition avec succès")
                    .then((result) => {
                        if (result.isConfirmed) {
                            router.push({
                                name: "newsList"
                            });
                        }
                    });
            })
            .catch((axiosError) => {
            swal.error("Une erreur est survenue lors de la modification");
            axiosError.response.data.errors.forEach((error) => {
                if (error.message.startsWith("Item not found for")
                    || error.message.startsWith("Could not convert database value")) {
                    swal.error("Une erreur est survenue au moment de la modification, l’uuid ajoutée n’existe pas.");
                    return false;
                }
            });
        });
    }
}

const onCancel = () => {
    swal.confirm(
        "Êtes-vous sûr de vouloir annuler l'édition ?",
        "Oui",
        "Non"
    ).then((result) => {
        if (result.isDismissed) {
            router.push({
                name: "newsList"
            });
        }
    });
}

const onImageWebUpload = (image) => {
    form.value.imageWeb = image;
}

const onImageMobileUpload = (image) => {
    form.value.imageMobile = image;
}

const onImageWebRemoved = () => {
    form.value.imageWeb = null;
}

const onImageMobileRemoved = () => {
    form.value.imageMobile = null;
}

const onImageUploadError = (errorMsg: string) => {
    swal.error(errorMsg);
}

function getBaseUrl() {
    return window.location.origin;
}

return (_ctx: any,_cache: any) => {
  const _component_FormKit = _resolveComponent("FormKit")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h1", _hoisted_2, _toDisplayString(title.value), 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _createVNode(UploadImage, {
                  "image-preview-url": form.value.imageWeb ? form.value.imageWeb.url : getBaseUrl() + '/media/blank2.png',
                  onImageRemoved: onImageWebRemoved,
                  onImageUploaded: onImageWebUpload,
                  onError: onImageUploadError
                }, null, 8, ["image-preview-url"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _hoisted_13,
                _createVNode(UploadImage, {
                  "image-preview-url": form.value.imageMobile ? form.value.imageMobile.url : getBaseUrl() + '/media/blank2.png',
                  onImageRemoved: onImageMobileRemoved,
                  onImageUploaded: onImageMobileUpload,
                  onError: onImageUploadError
                }, null, 8, ["image-preview-url"])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createVNode(_component_FormKit, {
                  type: "form",
                  actions: false,
                  model: form.value,
                  onSubmit: onSubmit,
                  "outer-class": "w-full",
                  "incomplete-message": "Veuillez remplir tous les champs correctement"
                }, {
                  default: _withCtx(({ state: { valid } }) => [
                    _createVNode(_component_FormKit, {
                      type: "text",
                      name: "produit",
                      modelValue: form.value.product,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.product) = $event)),
                      label: "Produit uuid *",
                      validation: "required",
                      "validation-messages": {
                    required: 'Ce champ est obligatoire.'
                }
                    }, null, 8, ["modelValue", "validation-messages"]),
                    _createVNode(_component_FormKit, {
                      type: "number",
                      name: "position",
                      label: "Position *",
                      value: form.value.position,
                      modelValue: form.value.position,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.position) = $event)),
                      validation: "required|min:1",
                      "validation-messages": {
                    required: 'Ce champ est obligatoire.',
                    min: 'Ce champ doit être un nombre décimal superieur à 0',
                }
                    }, null, 8, ["value", "modelValue", "validation-messages"]),
                    _createElementVNode("div", _hoisted_18, [
                      (loading.value === false)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                            _createVNode(_component_FormKit, {
                              type: "submit",
                              label: submitBtnLabel,
                              disabled: !valid,
                              class: _normalizeClass({ 'btn-primary': true, 'btn-block': true })
                            }, null, 8, ["disabled"])
                          ]))
                        : _createCommentVNode("", true),
                      _createVNode(_component_FormKit, {
                        type: "button",
                        label: "Annuler",
                        onClick: onCancel,
                        class: _normalizeClass({ 'btn-secondary': true, 'btn-block': true })
                      })
                    ])
                  ]),
                  _: 1
                }, 8, ["model"])
              ])
            ])
          ])
        ])
      ])
    ])
  ], 64))
}
}

})